let load = require('./helpers/browser/esm-js-loader-shards')(5);
module.exports = (load("65uD9")).then(() => parcelRequire('fglhK'));